import {
  createClient,
  SaveOperation,
  SearchOperation,
  postRequestFactory,
  searchRequestFactory,
  IdPathParameters
} from '@infuse/api/common';
import { AssignModel, OwnerResponse } from './owner-types';

const client = createClient('/rest/operator-api/onboarding/templates');

export const onboardingTemplateAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-onboarding-template',
  UNASSIGN: 'cpms.unassign-onboarding-template',
  SEARCH_OWNERS: 'cpms.search-onboarding-template-owners'
};

export type AssignOnboardingTemplateRequest = AssignModel;
export type UnassignOnboardingTemplateRequest = AssignModel;

export const assignOnboardingTemplate: SaveOperation<AssignOnboardingTemplateRequest, void, string> = postRequestFactory<
  AssignOnboardingTemplateRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: onboardingTemplateAccessManagementPermissions.ASSIGN
});

export const unassignOnboardingTemplate: SaveOperation<UnassignOnboardingTemplateRequest, void, string> = postRequestFactory<
  UnassignOnboardingTemplateRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: onboardingTemplateAccessManagementPermissions.UNASSIGN
});

export const getOnboardingTemplateOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: onboardingTemplateAccessManagementPermissions.SEARCH_OWNERS
});
